import { useMutation, type UseMutationResult } from 'react-query'

import { useAskYogiService } from 'features/ask-yogi/service'

export type FeedbackData = {
  message_uuid: string
  conversation_uuid: string
  is_positive: boolean
  issue_reason?: string | null
  additional_details?: string | null
}

export function useFeedbackMutation(
  projectId: string,
): UseMutationResult<unknown, unknown, FeedbackData> {
  const askYogiService = useAskYogiService()

  return useMutation(
    ({ conversation_uuid, message_uuid, ...feedback }: FeedbackData) =>
      askYogiService.sendFeedback(
        projectId,
        conversation_uuid,
        message_uuid,
        feedback,
      ),
    { meta: { operation: 'conversation.feedback.submit' } },
  )
}
